"use strict";

const EsriDynamicMapLayerFunctions = function () {
  var addMapClickListener = async function (map, mapLayers) {
    addPopUpCenterListener(map);
    map.on("click", async function (event) {
      const dataView = Tree.get("dataView");

      if (
        !(dataView === "roads" && ToolSettings.getSetting("group", "dataDrivenRoadCondition")) &&
        !["dry-weather"].includes(dataView)
      ) {
        return;
      }

      if (dataView === "dry-weather") {
        return;
      }

      if (Tree.get("enabledEsriLayers")?.length) {
        const currentEnabledLayerName = Tree.get("enabledEsriLayers")[0];
        if (!Tree.get(["layers", currentEnabledLayerName, "isEnabled"])) {
          return;
        }
      }

      const token = await EsriLayerFunctions.getEsriLayerToken();
      const esriKey = DataViewFunctions.getCurrentDataViewProperty("esriKey") || "parentView";
      const esriLayer =
        esriKey === "streetSweepingRoute"
          ? Tree.get("streetSweepingEsriLayer")
          : DataViewFunctions.getCurrentDataViewProperty("esriLayer");
      const layerId = EsriLayerFunctions.getLayerId(esriKey, esriLayer);
      const layerIdsToIdentify = EsriLayerFunctions.getLayerIdsToIdentify(esriKey);
      const skipSpatial = esriKey === "streetSweepingRoute" ? false : true;

      const identifyUrl = EsriLayerFunctions.getEsriLayerUrl(esriKey);
      const bounds = map.getBounds();
      const size = map.getSize();
      const layerDefsValue = EsriLayerFunctions.getLayerDefsValueByLayerId(
        esriKey,
        esriLayer,
        layerId,
        skipSpatial,
      );

      const identifyParams = {
        geometryType: "esriGeometryPoint",
        geometry: JSON.stringify({ x: event.latlng.lng, y: event.latlng.lat }),
        sr: 4326,
        layers: `visible:${layerIdsToIdentify.join(",")}`,
        tolerance: 5,
        mapExtent: `${bounds.getWest()},${bounds.getSouth()},${bounds.getEast()},${bounds.getNorth()}`,
        imageDisplay: `${size.x},${size.y},96`,
        layerDefs: JSON.stringify({ [layerId]: layerDefsValue }),
        returnGeometry: true,
        returnUnformattedValues: true,
        f: "json",
      };

      if (token) {
        identifyParams.token = token;
      }

      let featureCollection = null;
      try {
        const fetchResponse = await Network.fetchFrom(
          `${identifyUrl}/identify?${new URLSearchParams(identifyParams)}`,
        );
        const response = await fetchResponse.json();

        if (response.results?.length) {
          const features = [...response.results].reverse().map((result) => ({
            type: "Feature",
            id: result.attributes?.OBJECTID,
            properties: result.attributes,
            geometry: result.geometry || null,
            layerId: result.layerId,
          }));
          featureCollection = { type: "FeatureCollection", features };
        }
      } catch (error) {
        console.log(error);
      }

      Table.removeMapHoverHighlight();

      const topFeature = featureCollection?.features[0];
      if (!topFeature) {
        return;
      }
      const esriLayerName = EsriLayerFunctions.getEsriLayerNameByLayerId(
        esriKey,
        topFeature.layerId,
      );
      if (topFeature) {
        let popupContent;
        if (Tree.get("tool") === "assets") {
          return;
        } else if (esriLayerName === "maintenanceZone") {
          topFeature.properties.maintenanceZoneName = topFeature.properties.zone_name;
          topFeature.properties.acres = topFeature.properties.zone_area;
          popupContent = PopupContent.getLayerPopup(topFeature, "maintenanceZones");
        } else if (esriLayerName === "streams") {
          popupContent = PopupContent.getWatershedPopup(topFeature);
        } else if (esriLayerName === "manhole") {
          var dryWeatherPopupData = await ApiCalls.getIddeDryWeatherPopup(topFeature.id, "manhole");
          popupContent = DryWeatherFunctions.getDryWeatherLayerPopupHtml(dryWeatherPopupData);
        } else if (esriKey === "streetSweepingRoute") {
          popupContent = await StreetSweepingPopup.getStreetSweepingRoutePopup(
            topFeature,
            esriLayerName,
          );
        } else {
          topFeature.properties.catchid = topFeature.properties.CATCH_ID;
          topFeature.properties.drains_to_rw = topFeature.properties.DRAINS_TO_RW;
          topFeature.properties.drains_to_c = topFeature.properties.DRAINS_TO_C;
          popupContent = PopupContent.getLayerPopup(topFeature, "catchments");
        }

        L.popup(MapFunctions.getPopupOptions())
          .setLatLng(event.latlng)
          .setContent(popupContent)
          .openOn(map);

        if (esriLayerName === "manhole") {
          const $element = $(`.popup-general[data-popup-type="dryWeather"]`);
          DryWeatherFunctions.loadPopupListeners(dryWeatherPopupData, $element);
          DryWeatherHistory.renderDryWeatherHistory(
            dryWeatherPopupData.history,
            dryWeatherPopupData.assetType,
          );
        }
      }
    });
  };

  var addPopUpCenterListener = async function (map) {
    const dataView = Tree.get("dataView");
    if (dataView === "asset-management") {
      map.on("popupopen", function (e) {
        if (e.target._popup._latlng) {
          var px = map.project(e.target._popup._latlng);
          px.y -= e.target._popup._container.clientHeight / 2;
          map.panTo(map.unproject(px), { animate: true });
        }
      });
    }
  };

  return {
    addMapClickListener,
  };
};

module.exports = EsriDynamicMapLayerFunctions();

const ApiCalls = require("../apiCalls");
const DryWeatherFunctions = require("../illicitDischarge/dryWeatherFunctions");
const DryWeatherHistory = require("../illicitDischarge/dryWeatherHistory");
const DataViewFunctions = require("../dataViewFunctions");
const EsriLayerFunctions = require("./esriLayerFunctions");
const MapFunctions = require("./mapFunctions");
const Network = require("../network");
const PopupContent = require("./popupContent");
const StreetSweepingPopup = require("../muni/streetSweepingPopup");
const ToolSettings = require("../settings/toolSettings");
const Table = require("./table");
const Tree = require("../tree");
